// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__C6nLL","heading":"styles_heading__RPd84","paragraph":"styles_paragraph__GC_0s","link":"styles_link__wfiNo"};